import {
  ADD_CAMPAIGN_CASHBACKS,
  DELETE_CAMPAIGN_CASHBACKS,
  GET_CAMPAIGN_CASHBACK_PROFILE,
  GET_CAMPAIGN_CASHBACKS_LIST,
  HIDE_CAMPAIGN_CASHBACKS_LOADER,
  SET_CAMPAIGN_CASHBACK_PROFILE,
  SET_CAMPAIGN_CASHBACKS_LIST,
  SHOW_CAMPAIGN_CASHBACKS_LOADER,
  UPDATE_CAMPAIGN_CASHBACK_PROFILE,
} from "./actionTypes";

export const getCampaignCashbacksList = data => ({
  type: GET_CAMPAIGN_CASHBACKS_LIST,
  payload: data,
});

export const setCampaignCashbacksList = payload => ({
  type: SET_CAMPAIGN_CASHBACKS_LIST,
  payload,
});

export const showCampaignCashbacksListLoader = () => ({
  type: SHOW_CAMPAIGN_CASHBACKS_LOADER,
});

export const hideCampaignCashbacksListLoader = () => ({
  type: HIDE_CAMPAIGN_CASHBACKS_LOADER,
});

export const addCampaignCashback = (cashback = {}) => ({
  type: ADD_CAMPAIGN_CASHBACKS,
  payload: { cashback },
});

export const deleteCampaignCashback = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_CASHBACKS,
  payload: { id, data },
});

export const getCampaignCashbackProfile = id => ({
  type: GET_CAMPAIGN_CASHBACK_PROFILE,
  payload: id,
});

export const setCampaignCashbackProfile = payload => ({
  type: SET_CAMPAIGN_CASHBACK_PROFILE,
  payload,
});

export const updateCampaignCashbackProfile = (
  id,
  cashback = {},
  data = {}
) => ({
  type: UPDATE_CAMPAIGN_CASHBACK_PROFILE,
  payload: { id, cashback, data },
});
